import type { SortingState } from '@tanstack/react-table';
import { fallback } from '@tanstack/zod-adapter';
import z from 'zod';

const sortingColumnSchema = z.object({ id: z.string(), desc: z.boolean() });

export type TypedSortingState<TSortField extends string> = { id: TSortField; desc: boolean }[];

export function resolveSortingState<TSortField extends string>(
  sorting: SortingState,
  defaultSorting: TypedSortingState<TSortField>
): TypedSortingState<TSortField> {
  return sorting.length > 0 ? (sorting as TypedSortingState<TSortField>) : defaultSorting;
}

export function normalizeSortingChange<TSortField extends string>(
  next: SortingState,
  defaultSorting: TypedSortingState<TSortField>
): TypedSortingState<TSortField> {
  return next.length > 0 ? (next as TypedSortingState<TSortField>) : defaultSorting;
}

export function toSortQueryParams<TSortField extends string>(
  sorting: TypedSortingState<TSortField>
): {
  sort_by: TSortField;
  sort_direction: 'ASC' | 'DESC';
} {
  const column = sorting[0];
  return { sort_by: column.id, sort_direction: column.desc ? 'DESC' : 'ASC' };
}

export function requiredSortingSearchParam(defaultSorting: SortingState) {
  return fallback(z.array(sortingColumnSchema).min(1), defaultSorting).default(defaultSorting);
}

export function optionalSortingSearchParam() {
  return fallback(z.array(sortingColumnSchema).min(1).optional(), undefined).optional();
}
